import React, { useState, useEffect } from 'react';
import { ServiceSelector } from '../../smart/utils/images-loader/ServiceSelector';
import { Loader } from '../utils/loader/Loader';
import './bradcamarea.scss';

type props = {}

export const BradcamArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    const myLoader = ServiceSelector.select(props.filename);
    console.log('bredcam!!!!', myLoader)
    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        
        return <Loader />;
    }
    else
        return <div className={myLoader.background}>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="bradcam_text text-center logo">
                            <h2>{props.title}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
}